<script lang="ts">
  import { onMount } from "svelte";

  import { api, ApiError } from "../../lib/api";
  import { commerceEnabled, resolveAppConfig } from "../../lib/config";

  let error = $state("");
  // On iOS (App Store 3.1.1) / billing-disabled clouds we can't open the
  // Paddle portal in-app; point the user to the web instead.
  let unavailable = $state(false);

  onMount(async () => {
    if (!commerceEnabled(await resolveAppConfig())) {
      unavailable = true;
      return;
    }
    try {
      const { portal_url } = await api.portal();
      window.location.assign(portal_url);
    } catch (e) {
      error = e instanceof ApiError ? e.message : "Could not open billing portal";
    }
  });
</script>

<section class="max-w-3xl mx-auto px-6 py-16">
  <h1 class="text-3xl font-bold">Billing</h1>
  {#if unavailable}
    <p class="mt-6 text-slate-400">Manage your subscription on the Optio website.</p>
  {:else if error}
    <p class="mt-6 text-red-400">{error}</p>
  {:else}
    <p class="mt-6 text-slate-400">Opening the Paddle customer portal…</p>
  {/if}
</section>
